import { post, get } from '../Services/http';
import { load as loadCart } from './Cart.action';

export const QUOTATION_SAVED = 'QUOTATION_SAVED';
export const QUOTATION_ERROR = 'QUOTATION_ERROR';
export const QUOTATION_RECEIVE = 'QUOTATION_RECEIVE';

export const save = (quotationRequestModel) => (dispatch) => {
    post('/api/quotation', quotationRequestModel)
        .then(data => dispatch(setIsSaved(true)))
        .catch(ex => dispatch(setError(true)));
}

export const fetch = () => (dispatch) => {
    get('/api/quotation')
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(error => dispatch(setError(true)));
}

export const addQuotationToCart = (quotation) => (dispatch) => {
    post('/api/quotation/addToCart', quotation)
        .then(() => dispatch(loadCart()))
        .catch(error => dispatch(setError(true)));
}

const receive = (quotations) => ({
    type: QUOTATION_RECEIVE,
    payload: {
        quotations
    },
})

const setError = error => ({
    type: QUOTATION_ERROR,
    payload: {
        error,
    },
})

const setIsSaved = isSaved => ({
    type: QUOTATION_SAVED,
    payload: {
        isSaved
    }
})
